import { render } from "./addDistrict.vue?vue&type=template&id=4faadfcf&scoped=true"
import script from "./addDistrict.vue?vue&type=script&lang=js"
export * from "./addDistrict.vue?vue&type=script&lang=js"

import "./addDistrict.vue?vue&type=style&index=0&id=4faadfcf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4faadfcf"]])

export default __exports__